import { combineReducers } from 'redux';

import { createAction } from '@reduxjs/toolkit';
import questionnaireRoutesReducer from '../routes/slice';
import incomeReducer from './Income/reducer';
import nonUsFinancialAccountsReducer from './NonUSFinancialAccounts/reducer';
import notesReducer from './Notes/slice';
import personalDetailsReducer from './PersonalDetails/reducer';
import spouseIncomeReducer from './SpouseIncome/reducer';
import summaryReducer from './Summary/slice';
import taxesDeductionsReducer from './TaxesDeductions/reducer';
import previewQuestionnaireReducer from './togglePreviewSlice';
import businessInfoReducer from './BusinessInfo/reducer';
import additionalQuestionsReducer from './AdditionalQuestions/reducer';
import soleProprietorshipReducer from './SoleProprietorship/reducer';

export default combineReducers({
  personal_details: personalDetailsReducer,
  income: incomeReducer,
  spouseIncome: spouseIncomeReducer,
  taxesDeductions: taxesDeductionsReducer,
  nonUsFinancialAccounts: nonUsFinancialAccountsReducer,
  notes: notesReducer,
  questionnaireRoutes: questionnaireRoutesReducer,
  previewQuestionnaire: previewQuestionnaireReducer,
  summary: summaryReducer,
  businessInfo: businessInfoReducer,
  additionalQuestions: additionalQuestionsReducer,
  soleProprietorship: soleProprietorshipReducer,
});
